import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import Header from "./components/Header";
import PublicPage from "./pages/PublicPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import BoxesPage from "./pages/BoxesPage";
import StatisticsPage from "./pages/StatisticsPage";
import CalendarPage from "./pages/CalendarPage";
import TratamentosPage from "./pages/TratamentosPage";
import StockPage from "./pages/StockPage";
import TarefasPage from "./pages/TarefasPage";
import TratamentosExternosPage from "./pages/TratamentosExternosPage";
import PedidosPage from "./pages/PedidosPage";
import GestaoPage from "./pages/GestaoPage";
import HistoricoPage from "./pages/HistoricoPage";
import AuditoriaPage from "./pages/AuditoriaPage";
import AnimalForm from "./components/AnimalForm";
import SequestroForm from "./components/SequestroForm";
import "./App.css";

function ProtectedRoute({ children, tecnicoOnly = false }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="flex items-center justify-center min-h-screen text-muted-foreground">A carregar...</div>;
  if (!user) return <Navigate to="/login" />;
  if (tecnicoOnly && user.role === 'operacional') return <Navigate to="/" />;
  return children;
}

function AppContent() {
  const { user } = useAuth();
  const location = useLocation();
  const isPublic = !user && location.pathname === '/' ? true : location.pathname === '/adocao';
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        <Routes>
          <Route path="/" element={user ? <DashboardPage /> : <PublicPage />} />
          <Route path="/login" element={user ? <Navigate to="/" /> : <LoginPage />} />
          <Route path="/adocao" element={<PublicPage />} />
          <Route path="/adicionar" element={<ProtectedRoute><AnimalForm /></ProtectedRoute>} />
          <Route path="/adicionar/sequestro" element={<ProtectedRoute tecnicoOnly><SequestroForm /></ProtectedRoute>} />
          <Route path="/editar/:id" element={<ProtectedRoute><AnimalForm /></ProtectedRoute>} />
          <Route path="/boxes" element={<ProtectedRoute><BoxesPage /></ProtectedRoute>} />
          <Route path="/estatisticas" element={<ProtectedRoute tecnicoOnly><StatisticsPage /></ProtectedRoute>} />
          <Route path="/calendario" element={<ProtectedRoute tecnicoOnly><CalendarPage /></ProtectedRoute>} />
          <Route path="/stock" element={<ProtectedRoute tecnicoOnly><StockPage /></ProtectedRoute>} />
          <Route path="/tarefas" element={<ProtectedRoute><TarefasPage /></ProtectedRoute>} />
          <Route path="/tratamentos-externos" element={<ProtectedRoute><TratamentosExternosPage /></ProtectedRoute>} />
          <Route path="/tratamentos" element={<ProtectedRoute tecnicoOnly><TratamentosPage /></ProtectedRoute>} />
          <Route path="/pedidos" element={<ProtectedRoute tecnicoOnly><PedidosPage /></ProtectedRoute>} />
          <Route path="/gestao" element={<ProtectedRoute tecnicoOnly><GestaoPage /></ProtectedRoute>} />
          <Route path="/historico" element={<ProtectedRoute tecnicoOnly><HistoricoPage /></ProtectedRoute>} />
          <Route path="/auditoria" element={<ProtectedRoute tecnicoOnly><AuditoriaPage /></ProtectedRoute>} />
        </Routes>
      </main>
      {!isPublic && (
        <footer className="text-center py-3 text-sm text-muted-foreground border-t border-border mt-2">
          ANIMALOG - {new Date().getFullYear()}
        </footer>
      )}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppContent />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
